import classNames from 'classnames';
import {FCC} from 'types/react';

import styles from './DiscountLabel.module.css';

type Props = {
    className?: string;
    inactive?: boolean;
};
export const DiscountLabel: FCC<Props> = ({className, children, inactive}) => {
    return (
        <div
            className={classNames(styles.block, className, {
                [styles.inactive]: inactive,
            })}
        >
            {children}
        </div>
    );
};
